export const PRICE_PATTERN = /^[0-9]*((\.|,)[0-9]{0,2})?$/
